import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

/**
 * Account Not Supported Page
 * Displayed when a user logs in with only a Customer global role and no organization memberships.
 * This means they are a CropSwipe marketplace user whose features are not yet available in the web portal.
 */
@Component({
  selector: 'app-account-not-supported',
  standalone: true,
  imports: [],
  template: `
    <div class="login-page">
      <div class="login-container text-center">
        <img src="assets/images/logo-icon.png" alt="ADN Logo" class="login-logo" />

        <div class="mb-4">
          <i class="bi bi-rocket-takeoff fs-3rem text-primary"></i>
        </div>

        <h2 class="h3 mb-3">New Features Coming Soon</h2>

        <p class="text-muted mb-4">
          Your account has been created successfully. We're building new features for your account type
          that will be available soon. We'll notify you when they're ready.
        </p>

        <div class="d-grid gap-2">
          <button class="btn btn-outline-secondary" (click)="logout()">
            <i class="bi bi-box-arrow-right me-2"></i>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  `
})
export class AccountNotSupportedComponent {
  private authService = inject(AuthService);

  logout(): void {
    this.authService.logout();
  }
}
